interface WxUserInfo {
  openid: string;
  companyKey: string;
  memberCard: string;
  phone: string;
  headerImg: string;
  page: null | string;
  register_openid: null | string;
  cardNum: null | string;
  logoImg: null | string;
  localUrl: null | string;
  subscribe: string;
}

interface StorageData {
  wxUserInfo: WxUserInfo | null;
  ticket: string | null;
  memberCard: string | null;
  companyInfo: any | null;
}

export function getLocalStorage() {
  const wxUserInfo = localStorage.getItem('urlData');
  const companyInfo = localStorage.getItem('companyInfo');
  const storageData: StorageData = {
    wxUserInfo: null,
    ticket: null,
    memberCard: null,
    companyInfo: companyInfo ? JSON.parse(companyInfo) : null,
  };

  if (wxUserInfo) {
    const wxUserInfoJSON = JSON.parse(wxUserInfo);
    const ticket = localStorage.getItem(`ticket_${wxUserInfoJSON.companyKey}`);

    storageData.wxUserInfo = wxUserInfoJSON;
    storageData.ticket = ticket;
    storageData.memberCard = wxUserInfoJSON.memberCard || localStorage.getItem('memberCard');
  }

  return storageData;
}
